<template>
  <div>
  <nav aria-label="Page navigation example" id="inIbPagination" v-if="customer_self_policies_filterd.length > chunkSize">
    <ul class="pagination">

      <span class="page-item"><button class="page-link" :disabled="currentPage === 0"  @click="onChangePage('prev')">
        <!-- <i class="fa fa-chevron-left"></i> -->
        <img class="img-fluid in-icon-rotate--fix" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
        </button></span>

<!--      <span v-if="pageOfItems.length - currentPage == 1">-->
<!--          <span class="page-item" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index >currentPage-3"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>-->
      <span v-if="currentPage === 0">
        <span class="page-item d-flex" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index < currentPage+3"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>
      </span>
      <span v-if="currentPage === 1 && pageOfItems.length !== 2">
        <span class="page-item d-flex" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index < currentPage+2"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>
      </span>
      <span v-if="currentPage > 1 && currentPage !== pageOfItems.length-1 ">
        <span class="page-item d-flex" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index > currentPage-2 && index <currentPage+2"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>
      </span>
      <span v-if="currentPage === pageOfItems.length-1">
        <span class="page-item d-flex" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index > currentPage-3 && index <currentPage+2"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>
      </span>
<!--      <span v-if="currentPage > 2">-->
<!--        <span class="page-item d-flex" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index > currentPage-2 && index <currentPage+2"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>-->
<!--      </span>-->

<!--      </span>-->
<!--      <span v-if="pageOfItems.length - currentPage === 2">-->
<!--          <span class="page-item" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index > currentPage-2"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>-->
<!--      </span>-->
<!--      <span v-if="pageOfItems.length - currentPage > 2">-->
<!--          <span class="page-item" @click="onChangePage('jump',index)" v-for="(page,index) in pageOfItems" :key="index" v-if="index == currentPage || index <currentPage+3  && index > currentPage"><a class="page-link" :class="index == currentPage ? 'active': ''">{{index +1}}</a></span>-->
<!--      </span>-->
      <span class="page-item"><button :disabled="currentPage === pageOfItems.length-1" class="page-link" @click="onChangePage('next')">
        <!-- <i class="fa fa-chevron-right"></i> -->
        <img class="img-fluid" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
        </button></span>
    </ul>
    <span class="page-item"><p  class="page-link" style="font-family: 'Avenir Book';"> Total {{pageOfItems.length}} Page<span v-if="pageOfItems.length > 1">s</span></p></span>
  </nav>
  </div>
</template>

<script>
  export default{
    name:'PaginationComponent',
    props:{
      customer_self_policies_filterd:{},
      isShowing:{
        type:Boolean
      },
      chunkSize:{
        type:Number
      },
    },
  data(){
    return{
      currentPage:0,
      exampleItems:[],
      pageOfItems:[],
      dispalyItems:[],
      // noOfItemsPerPage:0,
      // chunkSize: 10,

    }
  },
 async created(){
    const self = this;
    setTimeout(()=> self.loadData(),1000);
 },
    watch:{
      customer_self_policies_filterd:function(newVal, oldVal){
        if(newVal){
          this.loadData();
        }

      },
      chunkSize:function(newVal, oldVal){
        if(newVal){
          this.loadData();
        }
      }
    },
    methods:{

    onChangePage(action,index = null){
      const self = this;
      if(action == 'prev'){
        if(self.currentPage > 0){
          self.dispalyItems = self.pageOfItems[self.currentPage -1];
          self.currentPage--;
        }else{
          return false;
        }
      }
      if(action == 'next'){
        self.dispalyItems = self.pageOfItems[self.currentPage +1];
        self.currentPage++;
      }
      if(action == 'jump'){
        self.currentPage = index;
        self.dispalyItems = self.pageOfItems[index];
      }
      self.$emit('updatedData',self.dispalyItems);
      self.$emit('updatedPage',self.currentPage);
    },
      loadData(){
        const self = this;
        self.currentPage = 0;
       // let chunkSize = 10;
        for (let i = 0; i < self.customer_self_policies_filterd.length; i += self.chunkSize) {
          const chunk = self.customer_self_policies_filterd.slice(i, i + self.chunkSize);
          self.exampleItems.push(chunk);
        }
        self.pageOfItems = self.exampleItems.filter(x => x.mainclass_name == self.customer_self_policies_filterd.mainclass_name);
        // console.log('page',self.pageOfItems);
        self.dispalyItems = self.pageOfItems[0];
        // console.log('display',self.dispalyItems);
        self.$emit('updatedData',self.dispalyItems);
        self.exampleItems = [];
        return self.exampleItems;

      },

  }
  }

</script>
<style>
#inIbPagination > ul > span > span > a.page-link,
#inIbPagination > ul > span > span > button.page-link,
#inIbPagination > ul > span > button
{
    border: none !important;
    box-shadow: 0 1px 7px 0px #00000033 !important;
    border-radius: 7px !important;
    color: var(--text-color) !important;
    display: inline-flex;
    min-height: 100%;
    align-items: center;
    justify-content: center;
    font-family: "Avenir Medium";
    cursor: pointer;
    min-width: 37px;
  }
  #inIbPagination > ul > span > span > a.page-link.active
{
    color: white !important;
  }
/* #inIbPagination > ul > span > span > a.page-link:not(.page-link.active){
    border: none;
    box-shadow: 0 1px 7px 0px #00000033;
    border-radius: 8px !important;
    color: var(--text-color) !important;
  } */
  /* nav#inIbPagination > ul.pagination > li.page-item.d-flex > span a.page-link{
    border: none;
    box-shadow: 0 1px 7px 0px #00000033;
    border-radius: 8px !important;
    color: var(--text-color) !important;
  } */
  nav#inIbPagination > ul.pagination > li.page-item.d-flex >  a.page-link.active{
    background-color: var(--primary-color) !important;
    color: white !important;
  }
  .page-link.active {
    background-color: var(--primary-color) !important;
    color: white !important;
  }
  nav#inIbPagination{
    margin: 2rem 1.3rem 0rem auto;
    display: flex;
    flex-direction: row-reverse;
  }
  nav#inIbPagination > ul.pagination span:not(.page-item){
    display: flex;
    flex: 1;
  }
  nav#inIbPagination > ul.pagination span.page-item{
    margin: 0px 3px !important;
  }
  p.page-link{
    border: none !important;
    color: var(--text-color) !important;
    border-radius: 15px !important;
  }
  p.page-link:hover{
    border: none !important;
    color: var(--text-color) !important;
    border-radius: 15px !important;
    background: none !important;
    background-color: transparent !important;
  }
  .in-icon-rotate--fix{
    transform: rotate(180deg);
  }
</style>



// WEBPACK FOOTER //
// src/components/PaginationComponent.vue